import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import Agent from './pages/Agent';
import ProductDescription from './pages/ProductDescription';
import ICPSelection from './pages/ICPSelection';
import Workflow from './pages/Workflow';
import WorkflowBuilder from './pages/WorkflowBuilder';
import WorkflowExecutions from './pages/WorkflowExecutions';
import Integrations from './pages/Integrations';
import Leads from './pages/Leads';
import People from './pages/People';
import JoinProject from './pages/JoinProject';
import NewProject from './pages/NewProject';
import Settings from './pages/Settings';
import Conversations from './pages/Conversations';
import Approvals from './pages/Approvals';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Navigate to="/signin" replace />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          
          {/* Protected Routes */}
          
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/agent" element={
            <ProtectedRoute>
              <Layout>
                <Agent />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/product-description" element={
            <ProtectedRoute>
              <Layout>
                <ProductDescription />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/icp-selection" element={
            <ProtectedRoute>
              <Layout>
                <ICPSelection />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/workflow" element={
            <ProtectedRoute>
              <Layout>
                <Workflow />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/integrations" element={
            <ProtectedRoute>
              <Layout>
                <Integrations />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/conversations" element={
            <ProtectedRoute>
              <Layout>
                <Conversations />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/leads" element={
            <ProtectedRoute>
              <Layout>
                <Leads />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/people" element={
            <ProtectedRoute>
              <Layout>
                <People />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/projects/join" element={
            <ProtectedRoute>
              <Layout>
                <JoinProject />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/projects/new" element={
            <ProtectedRoute>
              <Layout>
                <NewProject />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/settings" element={
            <ProtectedRoute>
              <Layout>
                <Settings />
              </Layout>
            </ProtectedRoute>
          } />

          {/* The Enrichment Table became Leads. Kept so old links still land. */}
          <Route path="/enrichment-table" element={<Navigate to="/leads" replace />} />
          
          <Route path="/approvals" element={
            <ProtectedRoute>
              <Layout>
                <Approvals />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/workflow/builder" element={
            <ProtectedRoute>
              <WorkflowBuilder />
            </ProtectedRoute>
          } />
          
          <Route path="/workflow/builder/:workflowId" element={
            <ProtectedRoute>
              <WorkflowBuilder />
            </ProtectedRoute>
          } />
          
          <Route path="/workflow/:workflowId/executions" element={
            <ProtectedRoute>
              <WorkflowExecutions />
            </ProtectedRoute>
          } />
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/signin" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
